function DeleteConfirmationModalController($scope,
                                           $uibModalInstance,
                                           communicationName) {
    const self = this;

    self.initialise = function() {
        $scope.communicationName = communicationName;
    }

    $scope.confirm = function() {
        $uibModalInstance.close(true);
    }

    $scope.close = function() {
        $uibModalInstance.close(false);
    }

    self.initialise();
}

angular
    .module("dashboard")
    .controller("DeleteConfirmationModalController",
        ["$scope",
        "$uibModalInstance",
        "communicationName",
        DeleteConfirmationModalController]);